<template>
  <div id="home">
    <Header :changeLocale="changeLocale" :languages="languages" />
    <TextBlock />
    <Prices />
    <Gallery />
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import TextBlock from "./components/TextBlock.vue";
import Prices from "./components/Prices.vue";
import Gallery from "./components/Gallery.vue";
import Footer from "./components/Footer.vue";
import i18n from "@/plugins/i18n";

export default {
  name: "home",
  components: {
    Header,
    TextBlock,
    Gallery,
    Prices,
    Footer
  },
  data() {
    return {
      languages: [
        { flag: "fr", language: "fr", title: "Français" },
        { flag: "us", language: "us", title: "English" }
      ]
    };
  },
  methods: {
    changeLocale(locale) {
      i18n.locale = locale;
    }
  }
};
</script>

<style>
@font-face {
  font-family: "Acre";
  src: url("./assets/fonts/Acre-Thin.woff2") format("woff2"),
    url("./assets/fonts/Acre-Thin.woff") format("woff");
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: "Acre";
  src: url("./assets/fonts/Acre-Medium.woff2") format("woff2"),
    url("./assets/fonts/Acre-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Acre";
  src: url("./assets/fonts/Acre-Extrabold.woff2") format("woff2"),
    url("./assets/fonts/Acre-Extrabold.woff") format("woff");
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: "Acre";
  src: url("./assets/fonts/Acre-Black.woff2") format("woff2"),
    url("./assets/fonts/Acre-Black.woff") format("woff");
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: "Acre";
  src: url("./assets/fonts/Acre-Semibold.woff2") format("woff2"),
    url("./assets/fonts/Acre-Semibold.woff") format("woff");
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: "Acre";
  src: url("./assets/fonts/Acre-Light.woff2") format("woff2"),
    url("./assets/fonts/Acre-Light.woff") format("woff");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: "Acre";
  src: url("./assets/fonts/Acre-Regular.woff2") format("woff2"),
    url("./assets/fonts/Acre-Regular.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Acre";
  src: url("./assets/fonts/Acre-Bold.woff2") format("woff2"),
    url("./assets/fonts/Acre-Bold.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "Neue Montreal";
  src: url("./assets/fonts/NeueMontreal-Medium.woff2") format("woff2"),
    url("./assets/fonts/NeueMontreal-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Neue Montreal";
  src: url("./assets/fonts/NeueMontreal-LightItalic.woff2") format("woff2"),
    url("./assets/fonts/NeueMontreal-LightItalic.woff") format("woff");
  font-weight: 300;
  font-style: italic;
}

@font-face {
  font-family: "Neue Montreal";
  src: url("./assets/fonts/NeueMontreal-Light.woff2") format("woff2"),
    url("./assets/fonts/NeueMontreal-Light.woff") format("woff");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: "Neue Montreal";
  src: url("./assets/fonts/NeueMontreal-Bold.woff2") format("woff2"),
    url("./assets/fonts/NeueMontreal-Bold.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "Neue Montreal";
  src: url("./assets/fonts/NeueMontreal-BoldItalic.woff2") format("woff2"),
    url("./assets/fonts/NeueMontreal-BoldItalic.woff") format("woff");
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: "Roobert";
  src: url("./assets/fonts/Roobert-Bold.woff2") format("woff2"),
    url("./assets/fonts/Roobert-Bold.woff") format("woff");
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: "Product Sans";
  src: url("./assets/fonts/ProductSans-BoldItalic.woff2") format("woff2"),
    url("./assets/fonts/ProductSans-BoldItalic.woff") format("woff");
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: "Product Sans";
  src: url("./assets/fonts/ProductSans-Regular.woff2") format("woff2"),
    url("./assets/fonts/ProductSans-Regular.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Product Sans";
  src: url("./assets/fonts/ProductSans-Italic.woff2") format("woff2"),
    url("./assets/fonts/ProductSans-Italic.woff") format("woff");
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: "Product Sans";
  src: url("./assets/fonts/ProductSans-Bold.woff2") format("woff2"),
    url("./assets/fonts/ProductSans-Bold.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}

@import url("https://fonts.googleapis.com/css?family=Nunito:800&display=swap");

body {
  width : 100vw;
  overflow-x: hidden;
  margin: 0;
}

html {
  margin: 0
}

#home {
  font-family: "Lato", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
